<template>
  <b-modal
    ref="modal-pre-order-excel"
    hide-footer
    :title="titleExcel"
    id="modal-pre-order-excel"
  >
    <b-row class="mb-4">
      <b-col cols="12">
        <b-form-group label="Danh sách cần xuất:">
          <b-form-radio-group v-model="selectedListExcel">
            <b-form-radio value="all">Tất cả các trang</b-form-radio>
            <b-form-radio value="filter">Theo bộ lọc</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </b-col>
      <b-col cols="12">
        <b-row v-if="selectedListExcel === 'all'">
          <b-col md="4">
            <b-form-group>
              <label>Từ ngày:</label>
              <date-picker
                placeholder="Từ ngày"
                class="form-control form-control-sm"
                :config="dpConfigs.date"
                v-model="apiParams.fromDate"
              ></date-picker>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label>Đến ngày:</label>
              <date-picker
                placeholder="Tới ngày"
                class="form-control form-control-sm"
                :config="dpConfigs.date"
                v-model="apiParams.toDate"
              ></date-picker>
            </b-form-group>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <SaveButton
      class="mr-3"
      :button-style="{ fontWeight: '600', minWidth: '70px', whiteSpace: 'nowrap' }"
      :is-busy="isSubmitting('export')"
      @click="exportToExcelStream"
    >
      <v-icon small class="text-white" v-b-tooltip>mdi-download</v-icon>
      <strong>Xuất Excel</strong>
    </SaveButton>

    <b-button
      style="width: 80px"
      variant="secondary"
      size="sm"
      :disabled="isSubmitting('export')"
      @click="$bvModal.hide('modal-pre-order-excel')"
    >
      <strong>Hủy</strong>
    </b-button>
  </b-modal>
</template>

<script>
// import Swal from 'sweetalert2';
import { validationMixin } from 'vuelidate';
// import { minLength } from 'vuelidate/lib/validators';

// import { currencyMask, unMaskPrice } from './../../utils/common';
import { checkPermissions } from '../../../utils/saveDataToLocal';
import { makeToastFaile } from '../../../utils/common';
// import { ORDER_STATUS, ORDER_CANCEL_STATUS } from '../../../utils/constants';
import { BASE_URL } from './../../../utils/constants';
import axios from 'axios';
import fileDownload from '../../../utils/file-download';
import datePicker from 'vue-bootstrap-datetimepicker';
// Import date picker css
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
import moment from 'moment';
import { cloneDeep } from 'lodash';
import SaveButton from '@/view/components/common/SaveButton.vue';
import submitLock from '@/view/mixins/submit-lock.mixins';
export default {
  props: ['param', 'mode'],
  mixins: [validationMixin, submitLock],
  data() {
    return {
      dpConfigs: {
        date: {
          format: 'DD/MM/YYYY',
          useCurrent: false,
          showClear: true,
          showClose: true,
          minDate: false,
          maxDate: false,
          locale: 'vi',
          sideBySide: true,
        },
      },
      selectedListExcel: 'all',
      apiParams: null,
      titleExcel: 'Xuất excel đơn đặt trước',
    };
  },
  components: {
    datePicker,
    SaveButton,
  },
  computed: {},
  created() {},
  watch: {
    $props: {
      handler() {
        this.apiParams = cloneDeep(this.param);
      },
      deep: true,
      immediate: true,
    },
  },
  validations: {},
  methods: {
    checkPermissions,
    exportToExcelStream() {
      return this.withSubmitLock('export', () => this.doExportToExcelStream());
    },
    doExportToExcelStream() {
      const baseUrl = BASE_URL;

      const apiParams = this.getParamFilters();

      if (!apiParams) {
        return;
      }

      return axios
        .get(`${baseUrl}pre-orders/export-excel`, {
          params: {
            ...apiParams,
          },
          responseType: 'blob',
        })
        .then((response) => {
          const fileName = fileDownload.getFileName(response);
          fileDownload.createFile(response.data, fileName);
        })
        .catch(async (error) => {
          this.$nprogress.done();
          const responseObj = JSON.parse(await error.response.data.text());
          return makeToastFaile(responseObj.message || 'Lỗi');
        });
    },
    getValuesMultiSelect(arr, prop) {
      return arr
        ? arr.reduce((accumulator, currentValue) => {
            if (currentValue.checked) accumulator.push(currentValue[prop]);
            return accumulator;
          }, [])
        : [];
    },
    getParamFilters() {
      const DATE_FORMAT = 'DD/MM/YYYY';
      const DATE_DB_FORMAT = 'YYYY-MM-DD';
      const fromDate = this.apiParams.fromDate
        ? moment(this.apiParams.fromDate, DATE_FORMAT).format(DATE_DB_FORMAT)
        : '1991-01-01';

      const toDate = this.apiParams.toDate
        ? moment(this.apiParams.toDate, DATE_FORMAT).format(DATE_DB_FORMAT)
        : moment().format('YYYY-MM-DD');

      const apiParams = {
        fromDate: fromDate,
        toDate: toDate,
      };

      if (this.selectedListExcel === 'filter') {
        const productSearch = this.apiParams.productSearch;

        if (
          productSearch &&
          productSearch.trim().length < 5 &&
          productSearch.trim().length > 1
        ) {
          makeToastFaile('Tên sản phẩm phải từ 5 kí tự trở lên');
          return null;
        }

        const filterParams = cloneDeep(this.apiParams);
        
        filterParams.status = filterParams.status.map((item) => item.id);
        if (filterParams.status.includes(-1)) {
          filterParams.status = [];
        }

        filterParams.storeIds = filterParams.storeIds.map((item) => item.id);
        if (filterParams.storeIds.includes(-1)) {
          filterParams.storeIds = [];
        }

        filterParams.formIds = filterParams.formIds.map((item) => item.id);
        if (filterParams.formIds.includes(-1)) {
          filterParams.formIds = [];
        }

        return {
          ...filterParams,
          ...apiParams,
          productSearch: productSearch ? productSearch.trim() : null,
        };
      }

      const diff = this.getDaysDiff(apiParams.fromDate, apiParams.toDate);
      if (diff > 100) {
        makeToastFaile('Vui lòng chọn khoảng thời gian trong vòng 3 tháng!');
        return null;
      }

      return apiParams;
    },
    getDaysDiff(startDate, endDate, dateFormat = 'YYYY-MM-DD') {
      const getDateAsArray = (date) => {
        return moment(date.split(/\D+/), dateFormat);
      };
      return (
        getDateAsArray(endDate).diff(getDateAsArray(startDate), 'days') + 1
      );
    },
  },
};
</script>
